import React from "react";
import { MapPin, ArrowUpRight } from "lucide-react";
import { destinations } from "../mock";

const Destinations = () => {
  return (
    <section id="bestemmingen" className="py-24 bg-[#fbfaf6]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="reveal flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="text-xs font-600 uppercase tracking-[0.25em] text-[#86233a]">Inspiratie</span>
            <h2 className="font-display mt-4 text-4xl lg:text-5xl font-600 text-[#1d1c1a]">
              Populaire bestemmingen
            </h2>
            <p className="mt-4 text-lg text-[#4b4642]">
              Even inspiratie opdoen? Dit zijn een paar favorieten. Jouw ideale
              plek staat er niet bij? Ik regel élke bestemming voor je.
            </p>
          </div>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 self-start rounded-full border border-[#530e2f]/25 px-6 py-3 text-[#530e2f] font-500 hover:bg-[#86233a] hover:text-white hover:border-[#86233a] transition-all duration-300"
          >
            Vraag advies aan <ArrowUpRight size={18} />
          </a>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {destinations.map((d) => (
            <a
              key={d.name}
              href="#contact"
              className="reveal group relative block rounded-2xl overflow-hidden shadow-[0_15px_40px_-20px_rgba(83,14,47,0.4)]"
            >
              <div className="img-zoom h-80">
                <img src={d.image} alt={`${d.name}, ${d.country}`} className="h-full w-full object-cover" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#530e2f]/90 via-[#530e2f]/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6 text-white">
                <div className="flex items-center gap-1.5 text-[#ffd7d4] text-xs uppercase tracking-[0.18em]">
                  <MapPin size={13} /> {d.country}
                </div>
                <h3 className="font-display text-3xl mt-1">{d.name}</h3>
                <p className="mt-2 text-sm text-white/85 max-h-0 opacity-0 group-hover:max-h-24 group-hover:opacity-100 overflow-hidden transition-all duration-500">
                  {d.text}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Destinations;
